import fieldIndices from './field-indices';

export function handleStartDateControlChange(event, setValueByIndex, setModifiedStateByIndex) {

  const value = event.target.value;

  setValueByIndex(fieldIndices.START_DATE_INDEX, value);

  setModifiedStateByIndex(fieldIndices.START_TIME_INDEX, true);

}

export function handleStartTimeControlChange(event, setValueByIndex) {

  const value = event.target.value;

  setValueByIndex(fieldIndices.START_TIME_INDEX, value);

}

export function handleEndDateControlChange(event, setValueByIndex, setModifiedStateByIndex) {

  const value = event.target.value;

  setValueByIndex(fieldIndices.END_DATE_INDEX, value);

  setModifiedStateByIndex(fieldIndices.END_TIME_INDEX, true);

}

export function handleEndTimeControlChange(event, setValueByIndex) {

  const value = event.target.value;

  setValueByIndex(fieldIndices.END_TIME_INDEX, value);

}

export function handleEventRecurringControlChange(option, setValueByIndex) {

  const value = option.value;

  setValueByIndex(fieldIndices.RECUR_TYPE_INDEX, value);

}

export function handleEventLocationControlChange(value, setValueByIndex) {

  setValueByIndex(fieldIndices.LOCATION_TYPE_INDEX, value);

}

export function handleEventLocationAddressControlChange(event, setValueByIndex) {

  const value = event.target.value;

  setValueByIndex(fieldIndices.LOCATION_VALUE_INDEX, value);

}

export function handleEventNotificationControlChange(option, setValueByIndex) {

  const value = option.value;

  setValueByIndex(fieldIndices.NOTIFY_BEFORE_INDEX, value);

}